import React from 'react'

function NoMedicineFound() {
    return (
        <div className="noDataFound">
            <p>No medicine(s) found</p>
        </div>
    )
}
export default NoMedicineFound